<template lang="pug">
div
  .form-groups
    .form-group.form-group--1-2 
      BriqInput(
        label="First Name" 
        name="Firstname"
        :placeholder="contactInformation.Firstname"
        :disabled="true"
        )
    .form-group.form-group--1-2
      BriqInput(
        label="Last Name" 
        name="Lastname"
        :placeholder="contactInformation.Lastname"
        :disabled="true"
        )
  BriqInput(
      label="Street" 
      name="Street"
      :placeholder="contactInformation.Street"
      :disabled="true"
      )
  .form-groups
    .form-group.form-group--1-2 
      BriqInput(
        label="House Number" 
        name="Housenumber"
        :placeholder="contactInformation.Housenumber"
        :disabled="true"
        )
    .form-group.form-group--1-2
      BriqInput(
        label="House Number Suffix" 
        name="HousenumberSuffix"
        :placeholder="contactInformation.HousenumberSuffix"
        :disabled="true"
        )
  BriqInput(
    label="Area" 
    name="Area"
    :placeholder="contactInformation.Area"
    :disabled="true"
    )
  .form-groups
    .form-group.form-group--1-2 
      BriqInput(
        label="City" 
        name="City"
        :placeholder="contactInformation.City"
        :disabled="true"
        )
    .form-group.form-group--1-2
      BriqInput(
        label="Zipcode" 
        name="Zipcode"
        :placeholder="contactInformation.Zipcode"
        :disabled="true"
        )
  .form-groups
    .form-group.form-group--1-2 
      BriqInput(
        label="Country" 
        name="Country"
        :placeholder="contactInformation.Country"
        :disabled="true"
        )
    .form-group.form-group--1-2
      BriqInput(
        label="State" 
        name="State"
        :placeholder="contactInformation.State"
        :disabled="true"
        )
  .form-groups
    .form-group.form-group--1-2 
      BriqInput(
        label="Email" 
        name="Email"
        :placeholder="contactInformation.Email"
        :disabled="true"
        )
    .form-group.form-group--1-2 
      BriqInput(
        label="Phone" 
        name="Phone"
        :placeholder="contactInformation.Phone"
        :disabled="true"
        )
  .form-groups
    .form-group.form-group--1-2 
      BriqInput(
        label="Chamber Of Commerce Number" 
        name="ChamberOfCommerceNumber"
        :placeholder="contactInformation.ChamberOfCommerceNumber"
        :disabled="true"
        )
    .form-group.form-group--1-2 
      BriqInput(
        label="Tax Number" 
        name="TaxNumber"
        :placeholder="contactInformation.TaxNumber"
        :disabled="true"
        )
</template>

<script>
export default {
    name: 'ContactInformationFields',
    props: {
        contactInformation: Object
    }
}
</script>